import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, HeartPulse, Building2, Gavel, Search, FolderOpen } from 'lucide-react';
const modules = [{
  icon: <BookOpen className="w-6 h-6" data-id="element-164" />,
  title: 'Fundamentos Clave para Litigar Casos de Salud con Seguridad',
  desc: 'Aprendé a identificar rápidamente el marco legal aplicable, entender el sistema de salud y construir reclamos sólidos desde el primer análisis del caso.'
}, {
  icon: <HeartPulse className="w-6 h-6" data-id="element-165" />,
  title: 'Coberturas Médicas, Medicamentos y Prestaciones: Cómo Reclamar con Éxito',
  desc: 'Todo lo que necesitás para abordar medicamentos, tratamientos, cirugías, discapacidad, fertilidad, salud mental y prestaciones complejas.'
}, {
  icon: <Building2 className="w-6 h-6" data-id="element-166" />,
  title: 'Obras Sociales y Prepagas: Estrategias para Resolver Conflictos Frecuentes',
  desc: 'Conocé cómo actuar frente a negativas de cobertura, reintegros, afiliaciones, bajas, permanencia y obstáculos contractuales.'
}, {
  icon: <Gavel className="w-6 h-6" data-id="element-167" />,
  title: 'Reclamos, Medidas Cautelares y Amparos Paso a Paso',
  desc: 'La metodología completa para estructurar reclamos previos, medidas cautelares y acciones de amparo con criterio práctico y profesional.'
}, {
  icon: <Search className="w-6 h-6" data-id="element-168" />,
  title: 'Prueba, Jurisprudencia y Argumentación que Fortalecen tu Caso',
  desc: 'Aprendé a seleccionar la documentación correcta, utilizar jurisprudencia estratégicamente y construir argumentos más sólidos.'
}, {
  icon: <FolderOpen className="w-6 h-6" data-id="element-169" />,
  title: 'Biblioteca Profesional Lista para Aplicar',
  desc: 'Accedé a checklists, modelos base, estructuras editables y herramientas diseñadas para ahorrar tiempo y trabajar con más seguridad.'
}];
export const Modules = () => {
  return <section className="py-20 bg-legal-800 border-y border-legal-700" data-id="element-170">
      <div className="container mx-auto px-4" data-id="element-171">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-172">
          <span className="inline-block text-gold-500 font-semibold tracking-widest uppercase text-sm mb-4" data-id="element-173">
            Contenido del Tratado
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-174">
            ¿Qué vas a encontrar dentro del Tratado Práctico de Derecho de la
            Salud?
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-175">
            6 módulos diseñados para llevarte del análisis del caso a la
            resolución, paso a paso.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4" data-id="element-176">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.08
        }} className="group flex gap-5 md:gap-6 bg-legal-900 border border-legal-700 hover:border-gold-500/50 rounded-xl p-6 md:p-7 transition-colors" data-id="element-177">
              {/* Number + icon */}
              <div className="shrink-0 flex flex-col items-center" data-id="element-178">
                <span className="font-serif text-4xl md:text-5xl font-bold text-gold-500/30 leading-none group-hover:text-gold-500/60 transition-colors" data-id="element-179">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span className="mt-3 flex items-center justify-center w-11 h-11 rounded-lg bg-gold-500/10 text-gold-500" data-id="element-180">
                  {mod.icon}
                </span>
              </div>

              <div className="border-l border-legal-700 pl-5 md:pl-6" data-id="element-181">
                <span className="text-xs font-semibold tracking-widest uppercase text-gold-500/80" data-id="element-182">
                  Módulo {idx + 1}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mt-1 mb-2 leading-snug" data-id="element-183">
                  {mod.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-184">{mod.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};